<template>
    <div class="view-container">
        <div class="header">
            <div class="login-box">
                <div class="title">
                    <div class="">
                        <span style="color: #F23B2F;font-weight: bold;">1</span>
                        <span style="color: #2C95FF;font-weight: bold;">+</span>
                        <span style="color: #F23B2F;font-weight: bold;">X</span>
                    </div>
                    短视频数据分析仿真平台
                </div>
                <CountDown @changeBeginExam="changeBeginExam" :timeObj="timeObj" />
                <div class="user-info">
                    <img :src="userAvatar ? userAvatar : require('../../../assets/images/user_img.png')" alt="">
                    <div class="user-name">{{userName}}</div>
                    <i @click="logoutBtn" class="iconfont logout-btn">&#xe60c;</i>
                </div>
            </div>
        </div>
        <div class="main">
          <div class="main-content">
            <div class="exam-name">{{examName}}</div>
            <div class="exam-type-box">
              <div class="exam-type-item" :style="isBeginExam ? 'cursor: pointer;':'cursor:not-allowed;'" v-for="item in examTypeList" @click="toExamDetail(item)">
                <div class="img-box" style="width: 322px;height: 200px;">
                  <img :src="item.imgSrc" alt="">
                </div>
                <div class="type-name">
                  <span class="text-overflow">{{item.name}}</span>
                  <i class="iconfont">&#xe62e;</i>
                </div>
              </div>
            </div>
<!--            <div class="exam-type-box">-->
<!--              <div class="exam-type" v-for="item in examTypeList" @click="toExamDetail(item)">-->
<!--                <div class="type-img">-->
<!--                  <img :src="item.imgSrc" alt="">-->
<!--                </div>-->
<!--                <span>{{item.name}}</span>-->
<!--              </div>-->
<!--              <div class="exam-type" style="height: 0;padding: 0;margin: 0"></div>-->
<!--              <div class="exam-type" style="height: 0;padding: 0;margin: 0"></div>-->
<!--            </div>-->
<!--            <div class="no-data" style="display: none">-->
<!--              暂无考试-->
<!--            </div>-->
          </div>
        </div>
    </div>
</template>

<script>
    import {userLogout, examStuExamPage} from '@/utils/apis'
    import CountDown from '../../../components/student/CountDown.vue'

    export default {
        name: "Exam",
        data() {
            return {
                userName: '',
                userAvatar: '',
                role: '',
              examTypeList:[
                {
                  id:null,
                  name:'理论考试',
                  path:'/student/examing/theoryTest/index',
                  imgSrc:require('./../../../assets/images/student/LiLunKS.png')
                },
                {
                  id:null,
                  name:'网店客户服务',
                  path:'/student/examing/onlineShopCustomerService/index',
                  imgSrc:require('./../../../assets/images/student/keHuKS.png')
                },
              ],
              timeObj:{
                begin_time:null,
                end_time:null,
              },
              examName:'',
              isBeginExam:false, // 是否已经开始考试
              isBeginExamTitle:'正在等待考试时间···',
            }
        },
        components: {
            CountDown
        },
        mounted() {
            this.role = localStorage.getItem('role');
            if (this.role === '5') {
                this.userName = localStorage.getItem('studentName');
                this.userAvatar = localStorage.getItem('studentAvatar');
            }
            this.getExamStuExamPage();
        },
        methods: {
            // 获取主页面信息
            getExamStuExamPage(){
              examStuExamPage().then((res)=>{
                this.examName = res.data.name;
                this.examTypeList[0].name = res.data.theory_name;
                this.examTypeList[0].id = res.data.theory_id;
                this.examTypeList[1].name = res.data.store_customer_name;
                this.examTypeList[1].id = res.data.store_customer_service;
                this.timeObj.begin_time = res.data.begin_time;
                this.timeObj.end_time = res.data.end_time;
                localStorage.setItem('end_time', this.timeObj.end_time);
                this.changeBeginExam();
              }).catch((err)=>{
                console.log('err',err)
              })
            },
            // 跳转考试详情
            toExamDetail(item){
              if(this.isBeginExam){
                this.$router.push({
                  path:item.path
                })
              }
            },
            // 是否可以点击考试
            changeBeginExam(num){
              if(num === 1){
                this.isBeginExam= true;
              } else if(num === 2){
                this.isBeginExamTitle = '考试时间未到！'
                this.isBeginExam= false;
              }

            },
            // 退出
            logoutBtn() {
                userLogout().then((res) => {
                    localStorage.clear();
                    this.$router.push('/');
                    this.$message.success(res.msg);
                }).catch((err) => {
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .view-container {
        width: 100vw;
        height: 100vh;
        min-width: 1200px;
        background: #F7F8FC;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .header {
            width: 100%;
            height: 60px;
            background: #fff;
            box-shadow: 0 2px 5px 0 rgba(15, 26, 54, 0.05);
            display: flex;
            z-index: 99;
            .login-box {
                width: 100%;
                font-size: 16px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;
                .title {
                    display: flex;
                    font-size: 20px;
                    font-weight: 400;
                    color: #333;
                }
                img {
                    height: 50px;
                    width: 94px;
                }
                .user-info {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-right: 10px;
                    }
                    .user-name {
                        width: 100px;
                        max-height: 50px;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .logout-btn {
                        cursor: pointer;
                        margin-left: 20px;
                        color: #F23B2F;
                    }
                }
            }
        }

        .main {
            width: 100%;
            height: 1%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url("./../../../assets/images/student/student-exam-bj-two.png") no-repeat center center;
            background-size: 100% 100%;
            .main-content{
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .exam-name{
                text-align: center;
                font-size: 30px;
                font-weight: 500;
              }
              .exam-type-box{
                display: flex;
                margin-top: 100px;
                .exam-type-item{
                  padding: 108px 128px 74px;
                  background: #fff;
                  border-radius: 8px;
                  border-top: 8px solid #F23B2F;
                  box-sizing: border-box;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  line-height: 1;
                  .img-box{
                    img{
                      max-width: 100%;
                      max-height: 100%;
                    }
                  }
                  .type-name{
                    margin-top: 60px;
                    display: flex;
                    align-items: center;
                    span{
                      font-size: 24px;
                      font-weight: 500;
                      margin-right: 20px;
                    }
                    i{
                      font-size: 24px;
                      color: #F23B2F;
                    }
                  }
                  &:first-of-type{
                    margin-right: 40px;
                  }
                }
              }
            }
        }
    }
</style>